export function LogoLilac(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="108"
        height="36"
        viewBox="0 0 108 36"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M107.286 13.632C106.109 12.1952 104.655 11.4767 102.924 11.4767C102.162 11.4767 101.452 11.6152 100.795 11.8922C100.154 12.1692 99.6001 12.55 99.1327 13.0347C98.6653 13.5022 98.2931 14.0648 98.0161 14.7226C97.7564 15.3805 97.6267 16.0902 97.6267 16.8519C97.6267 17.631 97.7564 18.3494 98.0161 19.0072C98.2931 19.6651 98.6653 20.2362 99.1327 20.7211C99.6174 21.2058 100.18 21.5867 100.821 21.8636C101.461 22.1406 102.154 22.2791 102.898 22.2791C104.525 22.2791 105.988 21.5867 107.286 20.2016V26.226L106.767 26.4079C105.988 26.6849 105.261 26.8838 104.586 27.0051C103.911 27.1436 103.244 27.2128 102.586 27.2128C101.236 27.2128 99.9377 26.9619 98.6913 26.4598C97.4622 25.9404 96.3715 25.222 95.4195 24.3046C94.4847 23.3696 93.7316 22.2705 93.1603 21.0067C92.5891 19.7257 92.3033 18.332 92.3033 16.826C92.3033 15.3199 92.5803 13.9436 93.1343 12.6972C93.7056 11.4335 94.4587 10.3515 95.3935 9.45129C96.3457 8.53379 97.4448 7.82402 98.6913 7.32198C99.9377 6.80263 101.245 6.54297 102.612 6.54297C103.391 6.54297 104.153 6.62952 104.897 6.80263C105.659 6.95845 106.455 7.20945 107.286 7.55569V13.632ZM83.7488 19.3963L81.4637 12.8786L79.1787 19.3963H83.7488ZM85.0992 23.2655H77.8284L76.6599 26.6671H71.2327L78.6852 7.08789H84.2423L91.6948 26.6671H86.2676L85.0992 23.2655ZM63.5597 22.3565V7.08789H58.4701V26.6671H69.662V22.3565H63.5597ZM54.3801 7.08789V26.6671H49.2905V7.08789H54.3801ZM40.5597 22.3565V7.08789H35.4701V26.6671H46.662V22.3565H40.5597Z"
          fill="#2B36BA"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15.6131 0L15.613 11.5409C15.613 13.6681 14.9567 15.7434 13.7335 17.4838L7.16857 26.8243C6.49237 27.7863 7.18054 29.1111 8.35649 29.1111H20.0821C21.183 29.1111 21.8833 27.9341 21.3583 26.9668C20.1143 24.6743 20.9644 21.8074 23.2568 20.5634L25.1617 19.5297L27.4142 23.6806C30.4303 29.2389 26.4062 36.001 20.0821 36.001H8.35647C1.60041 36.001 -2.35326 28.3897 1.53164 22.8624L8.09658 13.5219C8.50429 12.9418 8.72308 12.25 8.72308 11.5409L8.7231 6.88995C8.7231 3.08473 11.8078 4.46762e-08 15.6131 0Z"
          fill="url(#paint0_linear_8142_54504)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_8142_54504"
            x1="14.2179"
            y1="-4.11571e-09"
            x2="14.2835"
            y2="38.2392"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#2B36BA" />
            <stop offset="1" stopColor="#FF35D1" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}
